import moment from 'moment'
import 'moment/locale/es'
import { dineroDisabledMask } from '../Components/Items'

moment.locale('es')

const BIWO      = '00BFD6'
const BIWO_DARK = '007A8A'

const reporteFlujoDeTesorefiaPresentacionPdf = (values, chartPng) => {
  const empresa  = values.empresa  || {}
  const bancos   = values.bancos   || []
  const dias     = values.dias     || []
  const totales  = values.totales  || {}

  const saldoTotal = bancos.reduce((s, b) => s + (b.saldo || 0), 0)
  const saldoProy  = totales.saldoFinalProyectado || 0

  const empresaNombre = empresa.nombreComercial
    || (empresa.persona
        ? empresa.nombre
        : `${empresa.nombre || ''} ${empresa.apellidoPaterno || ''}`.trim())

  const periodoStr = `Hoy — ${moment(values.fechaFinal).locale('es').format('LL')}`

  const vencidas      = dias.find(d => d.fecha === 'VENCIDAS')
  const diasProyect   = dias.filter(d => d.fecha !== 'VENCIDAS')

  // ── Helpers ────────────────────────────────────────────────────────────────

  const border = {
    hLineWidth: () => 0.5,
    vLineWidth: () => 0.5,
    hLineColor: () => '#D9D9D9',
    vLineColor: () => '#D9D9D9',
  }

  const borderBiwo = {
    hLineWidth: () => 0.5,
    vLineWidth: () => 0.5,
    hLineColor: () => `#${BIWO}`,
    vLineColor: () => `#${BIWO}`,
  }

  const cell = (text, opts = {}) => ({
    text,
    fontSize: opts.sz   || 9,
    bold:     opts.bold || false,
    color:    opts.color || '#262626',
    alignment: opts.align || 'left',
    fillColor: opts.fill  || null,
    margin:    opts.margin || [4, 4, 4, 4],
  })

  const hdr = (text) => cell(text, { bold: true, color: '#FFFFFF', fill: `#${BIWO}`, align: 'center', sz: 9 })

  // KPI card (2-row mini-table: label + value)
  const kpiCard = (label, valor, fillLabel, fillValue, colorValue) => ({
    table: {
      widths: ['*'],
      body: [
        [cell(label, { bold: true, color: '#FFFFFF', fill: fillLabel, align: 'center', sz: 9, margin: [8, 8, 8, 4] })],
        [cell(dineroDisabledMask(valor), { bold: true, color: colorValue, fill: fillValue, align: 'center', sz: 15, margin: [8, 6, 8, 8] })],
      ],
    },
    layout: border,
  })

  // ── Tabla proyección diaria (primeros 10 días) ─────────────────────────────
  const topDias = diasProyect.slice(0, 10)
  const tablaBody = [
    [hdr('Fecha'), hdr('Saldo Inicial'), hdr('Por Cobrar (CXC)'), hdr('Por Pagar (CXP)'), hdr('Saldo Final')],
    ...topDias.map((d, i) => {
      const alt  = i % 2 === 1
      const fill = alt ? '#F5FBFC' : '#FFFFFF'
      const sf   = d.saldoFinal || 0
      return [
        cell(moment(d.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY'), { fill }),
        cell(dineroDisabledMask(d.saldoInicial), { fill, align: 'right' }),
        cell(dineroDisabledMask(d.porCobrar),    { fill, align: 'right', color: d.porCobrar > 0 ? '#237804' : '#262626' }),
        cell(dineroDisabledMask(d.porPagar),     { fill, align: 'right', color: d.porPagar  > 0 ? '#A8071A' : '#262626' }),
        cell(dineroDisabledMask(sf),             { fill, align: 'right', bold: true, color: sf >= 0 ? '#0050B3' : '#A8071A' }),
      ]
    }),
    // Totals row
    [
      cell('TOTALES DEL PERÍODO', { bold: true, fill: '#E6F7FF', align: 'center', sz: 9 }),
      cell('',                   { fill: '#E6F7FF' }),
      cell(dineroDisabledMask(totales.totalPorCobrar || 0), { bold: true, fill: '#E6F7FF', align: 'right', color: '#237804' }),
      cell(dineroDisabledMask(totales.totalPorPagar  || 0), { bold: true, fill: '#E6F7FF', align: 'right', color: '#A8071A' }),
      cell(dineroDisabledMask(saldoProy),                   { bold: true, fill: '#E6F7FF', align: 'right', color: saldoProy >= saldoTotal ? '#0050B3' : '#A8071A' }),
    ],
  ]

  // ── Tabla bancos ──────────────────────────────────────────────────────────
  const bancosBody = [
    [hdr('Banco'), hdr('Cuenta'), hdr('Moneda'), hdr('Saldo Actual')],
    ...bancos.map((b, i) => {
      const fill = i % 2 === 1 ? '#F5FBFC' : '#FFFFFF'
      return [
        cell(b.banco,  { fill }),
        cell(b.nombre, { fill }),
        cell(b.moneda, { fill, align: 'center' }),
        cell(dineroDisabledMask(b.saldo), { fill, align: 'right' }),
      ]
    }),
    [
      cell('TOTAL EN BANCOS', { bold: true, fill: '#E6F7FF', align: 'center', sz: 9 }),
      cell('', { fill: '#E6F7FF' }),
      cell('', { fill: '#E6F7FF' }),
      cell(dineroDisabledMask(saldoTotal), { bold: true, fill: '#E6F7FF', align: 'right' }),
    ],
  ]

  // ── Alerta de vencidas ────────────────────────────────────────────────────
  const alertaVencidas = vencidas && (vencidas.porCobrar > 0 || vencidas.porPagar > 0)
    ? [{
        table: {
          widths: ['*', '*', '*'],
          body: [
            [{ text: '⚠  MOVIMIENTOS VENCIDOS (anteriores a hoy)', colSpan: 3, fontSize: 9, bold: true, color: '#AD4E00', alignment: 'center', fillColor: '#FFF7E6', margin: [8, 6, 8, 6] }, {}, {}],
            [
              cell(`Por Cobrar: ${dineroDisabledMask(vencidas.porCobrar)}`,    { fill: '#FFF7E6', color: '#237804', align: 'center', bold: true }),
              cell(`Por Pagar: ${dineroDisabledMask(vencidas.porPagar)}`,     { fill: '#FFF7E6', color: '#A8071A', align: 'center', bold: true }),
              cell(`Balance: ${dineroDisabledMask(vencidas.saldoFinal - vencidas.saldoInicial)}`, { fill: '#FFF7E6', align: 'center', bold: true }),
            ],
          ],
        },
        layout: borderBiwo,
        margin: [0, 0, 0, 14],
      }]
    : []

  // ── Documento ─────────────────────────────────────────────────────────────
  const dd = {
    pageSize:        'LETTER',
    pageOrientation: 'landscape',
    pageMargins:     [30, 30, 30, 30],
    content: [

      // ════════════════════════════════════════
      // PÁGINA 1: Portada ejecutiva
      // ════════════════════════════════════════

      // Header principal
      {
        table: {
          widths: ['*'],
          body: [[{
            stack: [
              { text: 'FLUJO DE EFECTIVO — TESORERÍA', fontSize: 20, bold: true, color: '#FFFFFF', alignment: 'center' },
              { text: empresaNombre, fontSize: 11, color: '#E0F7FA', alignment: 'center', margin: [0, 4, 0, 0] },
              { text: `Período: ${periodoStr}`, fontSize: 10, color: '#B2EBF2', alignment: 'center' },
              { text: `Generado: ${moment().locale('es').format('LL')}`, fontSize: 9, color: '#B2EBF2', alignment: 'center', margin: [0, 2, 0, 0] },
            ],
            fillColor: `#${BIWO_DARK}`,
            margin: [20, 18, 20, 18],
          }]],
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 18],
      },

      // KPI Cards
      {
        columns: [
          kpiCard('SALDO EN BANCOS',        saldoTotal,                    `#${BIWO_DARK}`, '#F0FEFF', `#${BIWO_DARK}`),
          { width: 10, text: '' },
          kpiCard('TOTAL POR COBRAR',        totales.totalPorCobrar || 0,   '#135200',       '#F6FFED', '#237804'),
          { width: 10, text: '' },
          kpiCard('TOTAL POR PAGAR',         totales.totalPorPagar  || 0,   '#820014',       '#FFF1F0', '#A8071A'),
          { width: 10, text: '' },
          kpiCard(
            'SALDO FINAL PROYECTADO',
            saldoProy,
            saldoProy >= saldoTotal ? '#003A8C' : '#820014',
            saldoProy >= saldoTotal ? '#E6F7FF' : '#FFF1F0',
            saldoProy >= saldoTotal ? '#0050B3' : '#A8071A'
          ),
        ],
        margin: [0, 0, 0, 18],
      },

      // Alerta vencidas (condicional)
      ...alertaVencidas,

      // Sección bancos
      { text: 'Saldo Actual en Bancos', fontSize: 11, bold: true, color: `#${BIWO_DARK}`, margin: [0, 0, 0, 6] },
      {
        table: { widths: ['*', '*', 80, 120], body: bancosBody },
        layout: border,
      },

      // ════════════════════════════════════════
      // PÁGINA 2: Gráfica + tabla proyección
      // ════════════════════════════════════════
      { text: '', pageBreak: 'before' },

      {
        table: {
          widths: ['*'],
          body: [[{
            text: 'PROYECCIÓN DIARIA DE TESORERÍA',
            fontSize: 16, bold: true, color: '#FFFFFF', alignment: 'center',
            fillColor: `#${BIWO_DARK}`,
            margin: [20, 14, 20, 14],
          }]],
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 16],
      },

      // Gráfica
      ...(chartPng
        ? [{ image: chartPng, width: 732, height: 255, alignment: 'center', margin: [0, 0, 0, 16] }]
        : [{ text: '(Gráfica no disponible)', fontSize: 10, color: '#888', alignment: 'center', margin: [0, 20, 0, 20] }]
      ),

      // Tabla proyección
      { text: `Proyección — primeros ${topDias.length} días`, fontSize: 11, bold: true, color: `#${BIWO_DARK}`, margin: [0, 0, 0, 6] },
      {
        table: { widths: [90, '*', '*', '*', '*'], body: tablaBody },
        layout: border,
      },
    ],

    images: {
      logo: empresa.logo?.base64Completa || '',
    },

    defaultStyle: { font: 'Roboto' },
  }

  return dd
}

export default reporteFlujoDeTesorefiaPresentacionPdf
